export class LoginHelpTemplate{
    public MainTitle: string;
    public TitleIntro: string;
    public ForgetUsernameButtonLabel: string;
    public ResetPasswordButtonLabel: string;
    public RegisterNewUserLinkLabel: string;
    public LoginLinkLabel: string;
}